import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [ 'input' ]

	connect() {
		this.updateHighlight()
	}	

	updateHighlight(event) {
		if (this.inputTarget.checked) {
			this.addHighlight()
		} else {
			this.removeHighlight()
		}
	}

	addHighlight()    { this.element.classList.add('bg-primary-xlight') }
	removeHighlight() { this.element.classList.remove('bg-primary-xlight') }

}
